"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapHtml = exports.handleSubtypeNS = exports.handleAtts = exports.createElement = void 0;

var getAttributesHtml = props => Object.keys(props).reduce((html, propKey) => props[propKey] ? html += "".concat(propKey, "=\"").concat(props[propKey], "\" ") : html, "");

var getDatasetHtml = data => Object.keys(data).reduce((html, dataKey) => data[dataKey] ? html += " data-".concat(dataKey, "=\"").concat(data[dataKey], "\"") : html, "");

var setClassList = classList => classList && Array.isArray(classList) ? " class=\"".concat(classList.join(" "), "\" ") : " class=\"".concat(classList, "\" ");

var setElementAttributes = _ref => {
  var {
    classList,
    id,
    props,
    dataset
  } = _ref;
  return "".concat(setClassList(classList)).concat(id && "id=\"".concat(id, "\" ")).concat(getAttributesHtml(props)).concat(getDatasetHtml(dataset));
};

var createElement = _ref2 => {
  var {
    tagName = "div",
    classList = "",
    id = "",
    props = {},
    dataset = {},
    children = ""
  } = _ref2;
  return "<".concat(tagName || "div").concat(setElementAttributes({
    classList,
    id,
    props,
    dataset
  }), ">").concat(children, "</").concat(tagName || "div", ">");
};

exports.createElement = createElement;

var mapHtml = _ref3 => {
  var _htmlMap$type, _htmlMap$, _htmlMap$type2, _htmlMap$2;

  var {
    props,
    htmlMap
  } = _ref3;
  var {
    type,
    subtype
  } = props;

  var setDefaultClassList = (type, subtype) => [...(type ? [type] : []), ...(subtype ? [subtype.replace(":", " ")] : [])];

  if (!htmlMap) return {
    classList: setDefaultClassList(type, subtype)
  };
  var maps = [(_htmlMap$type = htmlMap[type]) === null || _htmlMap$type === void 0 ? void 0 : _htmlMap$type[subtype], (_htmlMap$ = htmlMap["*"]) === null || _htmlMap$ === void 0 ? void 0 : _htmlMap$[subtype], (_htmlMap$type2 = htmlMap[type]) === null || _htmlMap$type2 === void 0 ? void 0 : _htmlMap$type2["*"], (_htmlMap$2 = htmlMap["*"]) === null || _htmlMap$2 === void 0 ? void 0 : _htmlMap$2["*"]];

  var getClassList = classList => classList && (Array.isArray(classList) ? classList : [classList]);

  var result = maps.reduce((_result, map) => {
    var _map = map || {};

    var {
      classList,
      tagName,
      id
    } = typeof _map === 'function' ? _map(props) : _map;
    _result.classList = _result.classList.concat(getClassList(classList) || []);
    if (!_result.tagName && tagName) _result.tagName = tagName;
    if (!_result.id && id) _result.id = id;
    return _result;
  }, {
    classList: [],
    tagName: ""
  });
  return {
    classList: result.classList.length ? [...new Set(result.classList)] : setDefaultClassList(type, subtype),
    tagName: result.tagName,
    id: result.id
  };
};

exports.mapHtml = mapHtml;

var handleAtts = atts => atts ? Object.keys(atts).reduce((attsProps, key) => {
  attsProps["atts-".concat(key)] = typeof atts[key] === "object" ? atts[key].join(",") : atts[key];
  return attsProps;
}, {}) : {};

exports.handleAtts = handleAtts;

var handleSubtypeNS = subtype => {
  var subtypes = subtype.split(":");
  return subtypes.length > 1 ? {
    "subtype-ns": subtypes[0],
    subtype: subtypes[1]
  } : {
    subtype
  };
};

exports.handleSubtypeNS = handleSubtypeNS;